import styled from 'styled-components';
import { tertiaryColor } from '@styles/utils';

export const ImageStyle = styled.img`
  &.lazyload:not([src]) {
    visibility: hidden;
  }

  &.lazyload,
  &.lazyloading {
    background: ${tertiaryColor(200)};
  }
`;
